<template>
  <div>
    <div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        size="mini"
      >
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item
                label="货源单code"
                style="display:none"
              >
                <el-input
                  v-model="form.code"
                  :disabled="true"
                />
              </el-form-item>
              <el-form-item label="剩余数量">
                <el-input
                  v-model="form.lastWeight"
                  :disabled="true"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="剩余车数">
                <el-input
                  v-model="form.notReceivedCount"
                  :disabled="true"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="运费单价">
                <el-input
                  v-model="form.source"
                  :disabled="true"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item
                label="调整单价"
                prop="price"
              >
                <el-input v-model="form.price" @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'price')" />
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-button
        type="primary"
        @click="Modifyprice"
      >
        确定
      </el-button>
    </div>
  </div>
</template>
<script>
import { ModifypriceApi } from '@/api/orderform'
import { validatenumber } from '@/utils/validate.js'

export default {
    data() {
        return {
            form: {
                lastweight: '',
                lastcoalNumber: '',
                source: '',
                code: '',
                price: '',
            },
            emptyForm:{},
            rules: {
                price: [
                    {
                        required: true,
                        validator(rule, value, callback) {
                            validatenumber(value)
                                ? callback()
                                : callback(new Error('请输入调整单价(数字类型)'))
                        },
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    created() {
      this.emptyForm = JSON.parse(JSON.stringify(this.form))
    }, 
    methods: {
        Modifyprice() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    const rLoading = this.openLoading()
                    ModifypriceApi(this.form).then((response) => {
                        rLoading.close()
                        this.$message({
                            message: response.msg,
                            type: 'success',
                        })
                        this.$emit('guanbi')
                    })
                } else {
                    return false
                }
            })
        },
        Getdistr(row) {
            this.form = JSON.parse(JSON.stringify(this.emptyForm))
            this.form.code = row.code
            this.form.lastWeight = row.lastWeight
            this.form.lastCoalNumber = row.lastCoalNumber
            this.form.notReceivedCount = row.notReceivedCount
            this.form.source = row.price
        },
    },
}
</script>
<style lang="scss" scoped>
.dialog-footer {
    margin-top: 50px;
}
.titleh1 {
    line-height: 50px;
    border-bottom: 1px solid #e2e2e2;
    margin-bottom: 15px;
    code {
        width: 5px;
        height: 20px;
        background-color: #ff7f21;
        float: left;
        margin-right: 5px;
        margin-top: 13px;
    }
}
</style>
